import OpalAccordionCardV1 from "../OpalAccordionCardV1/OpalAccordionCardV1";
import OpalAccordionCardV2 from "../OpalAccordionCardV2/OpalAccordionCardV2";

const OpalCardFactory = (type, props) => {
  switch (type) {
    case 'v1':
      return <OpalAccordionCardV1 {...props} />;
    case 'v2':
      return <OpalAccordionCardV2 {...props} />;
    default:
      return <OpalAccordionCardV1 {...props} />;
  }
};

export default OpalCardFactory;
